import map from 'lodash/map.js';

class MiddlewareRunner {
    /**
     * @param store
     * @param router
     */
    constructor(store, router) {
        this.store = store;
        this.router = router;
    }

    /**
     * Sequentially run provided middleware `fire` methods.
     * @param to
     * @param from
     * @returns {Promise<any>}
     */
    run(to, from) {
        return new Promise(resolve => {
            if (!to.meta.middleware) {
                resolve();

                return;
            }

            if (!to.meta.ability) {
                throw new Error('The middleware must provide an ability to check');
            }

            const { ability } = to.meta;

            const middleware = map(to.meta.middleware, MiddlewareStep => () => {
                return new MiddlewareStep(this.store, this.router).fire(to, from, ability);
            }).concat(() => Promise.resolve());

            middleware
                .reduce(
                    (previous, current) =>
                        previous
                            .then(() => current())
                            .catch(error => {
                                throw error;
                            }),
                    Promise.resolve(false)
                )
                .then(() => resolve())
                .catch(error => {
                    this.handleError(error, { to, from });

                    resolve();
                });
        });
    }

    /**
     * @param error
     * @param intended
     */
    handleError(error, intended) {
        const type = error.constructor.name;

        if (type === 'ForbiddenError' || type === 'GateAccessDenied') {
            this.router.push({
                name: '403',
                params: {
                    to: {
                        name: intended.to.name,
                        params: intended.to.params,
                        path: intended.to.path,
                    },
                    from: intended.from,
                },
            });
        }
    }
}

export default MiddlewareRunner;
